export default theme => ({

  toolbar: {
    minHeight: theme.spacing.unit * 6,
    paddingLeft: theme.spacing.unit * 2.5,
    paddingRight: theme.spacing.unit * 2.5
  }

})



// WEBPACK FOOTER //
// ./src/styles/components/CardTitle.js